import React from "react"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import ImageContentful from "../ImageContentful"
import Snippet from "../Snippet"
import { media, mixins } from "../../styles"

const Wrapper = styled.div`
  h2 {
    ${mixins.copy5}
    color: var(--color-sage);
    margin-bottom: 30px;
    text-align: center;

    @media ${media.md} {
      margin-bottom: 50px;
    }

    @media ${media.xl} {
      margin-bottom: 75px;
    }
  }
`

const Logos = styled.ul`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;

  @media ${media.md} {
    flex-flow: row nowrap;
    justify-content: space-between;
  }
`

const Logo = styled.li`
  flex: 0 0 auto;
  height: 42px;
  margin: 0 0 30px;
  max-width: 50%;
  width: 90px;

  @media ${media.md} {
    flex: 1;
    margin-bottom: 0;
  }

  @media ${media.xl} {
    flex: none;
    height: 56px;
    width: 144px;
  }

  .gatsby-image-wrapper {
    width: 100%;
  }

  a {
    display: block;
  }

  img {
    display: block;
    height: auto;
    filter: saturate(0%) brightness(70%) contrast(1000%);
    width: 100%;
  }
`

const ClientLogos = ({ logos }) => {
  return (
    <Wrapper>
      <Container>
        <h2>
          <Snippet id="homePartnerLogos" field="header" />
        </h2>
        <Row>
          <Col md="10" mdOffset="1">
            <Logos>
              {logos.map((company, i) => (
                <Logo key={i}>
                  <ImageContentful
                    alt={company.name}
                    image={
                      company.logoInlined || company.logoAligned || company.logo
                    }
                  />
                </Logo>
              ))}
            </Logos>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default ClientLogos
